import React from 'react';
import { PitcherOverviewSprayChart } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import ReportCard from '../../../../components/ReportCard';
import { useMultiVideoFn, usePitchVideoFn } from '../../../../data';
import { VideoPlayerModal } from '../../../../components/VideoPlayer';

const SprayChart = ({ isLhb, pitches }) => {
    const { t: translate } = useTranslation();
    const pitchVideoFn = usePitchVideoFn();
    const multiVideoFn = useMultiVideoFn();
    const title = [
        translate('pitcher-overview.sections.spray-chart'),
        translate('baseball.abbr-versus'),
        translate(isLhb ? 'baseball.lhh' : 'baseball.rhh'),
    ].join(' ');
    return (
        <ReportCard title={title}>
            <PitcherOverviewSprayChart
                pitches={pitches}
                translate={translate}
                pitchVideoFn={pitchVideoFn}
                multiVideoFn={multiVideoFn}
                videoPlayerModal={VideoPlayerModal}
            />
        </ReportCard>
    );
};

export default SprayChart;
